import { Component, Input, OnInit } from '@angular/core';
import { TicketInviteModel } from '@fgb/core';

@Component({
  selector: 'fgbcl-ticket-invite-list',
  templateUrl: './ticket-invite-list.component.html',
  styleUrls: ['./ticket-invite-list.component.scss'],
})
export class TicketInviteListComponent implements OnInit {
  @Input() ticketInvite: TicketInviteModel;

  constructor() {}

  ngOnInit(): void {}
}
